import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Plus, Edit, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { useSettings } from "@/context/SettingsContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

const inputCls = "w-full rounded-lg border border-slate-200 px-3 py-2 text-sm focus:outline-none focus:border-[#0077B6]";
const empty = { city: "", name: "", is_active: true, order: 0 };

export default function AdminOtogars() {
  const [list, setList] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(empty);
  const [editId, setEditId] = useState(null);
  const { reload } = useSettings();

  const load = () => api.get("/admin/otogars").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    const payload = { ...form, order: Number(form.order) };
    try {
      if (editId) await api.put(`/admin/otogars/${editId}`, payload);
      else await api.post("/admin/otogars", payload);
      toast.success("Kaydedildi");
      setOpen(false); load(); reload();
    } catch (err) { toast.error(formatApiError(err)); }
  };

  const del = async (id) => {
    if (!window.confirm("Silmek istediğinize emin misiniz?")) return;
    await api.delete(`/admin/otogars/${id}`);
    toast.success("Silindi"); load(); reload();
  };

  return (
    <div data-testid="admin-otogars">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="font-display text-3xl font-extrabold tracking-tight">Otogarlar</h1>
          <p className="text-sm text-slate-500 mt-1">Müşterilerin siparişlerini teslim alabilecekleri otogarları yönetin.</p>
        </div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild>
            <button onClick={() => { setForm(empty); setEditId(null); setOpen(true); }} className="btn-primary" data-testid="add-otogar"><Plus size={16}/> Yeni Otogar</button>
          </DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle>{editId ? "Otogarı Düzenle" : "Yeni Otogar"}</DialogTitle></DialogHeader>
            <form onSubmit={submit} className="space-y-3">
              <input required placeholder="Şehir (örn: İstanbul)" className={inputCls} value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} />
              <input required placeholder="Otogar adı (örn: İstanbul Esenler Otogarı)" className={inputCls} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
              <input type="number" placeholder="Sıra" className={inputCls} value={form.order} onChange={(e) => setForm({ ...form, order: e.target.value })} />
              <label className="flex items-center gap-2 text-sm">
                <input type="checkbox" checked={form.is_active} onChange={(e) => setForm({ ...form, is_active: e.target.checked })} /> Aktif
              </label>
              <button className="btn-primary w-full">Kaydet</button>
            </form>
          </DialogContent>
        </Dialog>
      </div>

      <div className="bg-white rounded-2xl border border-slate-100 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50"><tr className="text-left">
            <th className="p-3">Şehir</th><th>Otogar</th><th>Sıra</th><th>Durum</th><th></th>
          </tr></thead>
          <tbody>
            {list.map((o) => (
              <tr key={o.id} className="border-t">
                <td className="p-3 font-semibold">{o.city}</td>
                <td>{o.name}</td>
                <td>{o.order}</td>
                <td><span className={`text-xs px-2 py-0.5 rounded-full ${o.is_active ? "bg-emerald-100 text-emerald-700" : "bg-slate-100"}`}>{o.is_active ? "Aktif" : "Pasif"}</span></td>
                <td className="text-right pr-4">
                  <button onClick={() => { setForm(o); setEditId(o.id); setOpen(true); }} className="p-2 text-[#0077B6]"><Edit size={15}/></button>
                  <button onClick={() => del(o.id)} className="p-2 text-rose-600"><Trash2 size={15}/></button>
                </td>
              </tr>
            ))}
            {list.length === 0 && <tr><td colSpan={5} className="p-10 text-center text-slate-600">Henüz otogar yok.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
